import React from "react";
import { authProvider } from "../context/authProvider";
import { useNavigate } from "react-router-dom";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionNotificaciones } from "../components/TableAdministracionNotificaciones";
import "../theme/ReporteCierreDia.css";

export const AdminPageNotificaciones = () => {
  const navigate = useNavigate();

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div> Administración de Notificaciones</div>
                </div>
              </div>
              <div>
                <TableAdministracionNotificaciones />
              </div>
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
